import { FunctionComponent } from 'react';
import styles from "./CatchRatePerformanceCard.module.css";
import cn from 'classnames';

interface ICatchRatePerformanceCardProps {
    successRate: number;
    totalTrips: number;
    successfulTrips: number;
    unsuccessfulTrips: number;
    tournamentWins: number;
    className?: string;
};

const CatchRatePerformanceCard: FunctionComponent<ICatchRatePerformanceCardProps> = ({
    successRate,
    totalTrips,
    successfulTrips,
    unsuccessfulTrips,
    tournamentWins,
    className
}) => {
    
    return (
        <div className={cn(styles.catchRatePerformanceCard, className)}>
            <div className={styles.header}>
                <div className={cn(styles.cardTitle)}>Catch Rate Performance</div>
                <div className={cn(styles.cardSummary)}>Success Rate</div>
            </div>
            <div className={styles.body}>
                <div className={styles.progressBarWrap}>
                    <span className={styles.progressBarCount} style={{left: `${successRate}%`}}>{`${successRate}%`}</span>
                    
                    <div className={styles.greenBar} style={{width: `${successRate}%`}}>
                        <div className={styles.blueBar} />
                    </div>
                </div>
            </div>
            <div className={styles.footer}>
                <div className={cn(styles.footerCard, styles.totalTrips)}>
                    <div className={cn(styles.footerCardTitle)}>{totalTrips}</div>
                    <div className={cn(styles.footerCardSummary)}>Total Trips</div>
                </div>
                <div className={cn(styles.footerCard, styles.successfulTrips)}>
                    <div className={cn(styles.footerCardTitle)}>{successfulTrips}</div>
                    <div className={cn(styles.footerCardSummary)}>Successful Trips</div>
                </div>
                <div className={cn(styles.footerCard, styles.unsuccessfulTrips)}>
                    <div className={cn(styles.footerCardTitle)}>{unsuccessfulTrips}</div>
                    <div className={cn(styles.footerCardSummary)}>Unsuccessful Trips</div>
                </div>
                <div className={cn(styles.footerCard, styles.tournamentWins)}>
                    <div className={cn(styles.footerCardTitle)}>{tournamentWins}</div>
                    <div className={cn(styles.footerCardSummary)}>Tournament Wins</div>
                </div>
            </div>
        </div>
    );
};

export default CatchRatePerformanceCard;
